import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

interface PublicRouteProps {
    children: React.ReactNode;
}

const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {
    const token = localStorage.getItem('token');
    const location = useLocation();
    const redirectTo = (location.state as any)?.from || '/wallet';

    if (token) {
        return <Navigate to={typeof redirectTo === 'string' ? redirectTo : `${redirectTo?.pathname || '/wallet'}${redirectTo?.search || ''}`} replace />;
    }

    return <>{children}</>;
};

export default PublicRoute;
